var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthDiaryNewEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#febe10;}.cls-2{fill:#fffbc5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_127_copy",
    "data-name": "Layer 127 copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "litter_expenses_new_entry",
    "data-name": "litter expenses new entry"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 299.77,
    cy: 301,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.09,245.55H356.82V160.37a56.2,56.2,0,0,0-56-56h0a56.18,56.18,0,0,0-56,56v85.18H164.6a56.18,56.18,0,0,0-56,56h0a56.18,56.18,0,0,0,56,56h80.17v85.27a56.2,56.2,0,0,0,56,56h0a56.2,56.2,0,0,0,56-56V357.6H447a56.2,56.2,0,0,0,56-56h0A56.2,56.2,0,0,0,447.09,245.55Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthDiaryNewEntry);
export default __webpack_public_path__ + "static/media/health_diary_new_entry.f20763ccaa8cdcc266b01addf54b63ec.svg";
export { ForwardRef as ReactComponent };